var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.274 14.893"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4b4b4b",
    d: "M7.937 5.399 12.554.147a.37.37 0 0 1 .3-.148h2.057a.4.4 0 0 1 .231.079.326.326 0 0 1 .049.479l-5.87 6.677 5.372 7.12a.327.327 0 0 1-.088.475.4.4 0 0 1-.209.062h-2.8a.37.37 0 0 1-.311-.162L7.334 9.492l-4.617 5.251a.37.37 0 0 1-.3.148H.366a.4.4 0 0 1-.231-.079.326.326 0 0 1-.049-.479l5.87-6.676L.582.538A.327.327 0 0 1 .666.063.4.4 0 0 1 .875.001h2.8a.37.37 0 0 1 .311.162l3.952 5.238Z",
    "data-name": "Path 45896"
  })));
};
export default SvgTwitter;